import type { CreateAndOpenProjectArgs } from '@heidi/agents/contracts';
import { buildCreateRoutineWithHeidiWirePrompt } from '@heidi/agents/contracts';

/**
 * Shared args for the "Create with Heidi" routine-setup chat.
 * `prompt` is agent wire text; `displayPrompt` is the user's opening bubble.
 * Omit `title` so create defaults to the "New chat" placeholder and the
 * harness LLM can auto-title both sidebar and header after the first turn.
 */
export function getCreateRoutineWithHeidiArgs({
  description,
  openingMessage,
}: {
  description: string;
  openingMessage: string;
}): CreateAndOpenProjectArgs {
  const trimmed = description.trim();
  return {
    prompt: buildCreateRoutineWithHeidiWirePrompt({
      description: trimmed,
      openingMessage,
    }),
    displayPrompt: trimmed,
    openingAssistantMessage: openingMessage,
  };
}
